var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 74,
    viewBox: "0 0 66 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1239 37.4304C51.4781 37.5586 52.4535 37.6773 53.5888 37.1444C55.018 36.4734 57.1043 37.2486 56.6641 37.8062C56.4919 38.0242 55.8663 38.2942 55.145 38.6055C54.0214 39.0903 52.6658 39.6753 52.4307 40.3199C52.1218 41.1667 51.7148 41.4162 51.5499 41.4351L51.5491 41.4271C51.3786 41.4409 50.9342 41.2834 50.4587 40.5379C50.0915 39.9622 48.6441 39.6985 47.4445 39.4799C46.6743 39.3395 46.0063 39.2178 45.7918 39.0441C45.2431 38.5998 47.1126 37.3713 48.6503 37.7023C49.8804 37.967 50.8111 37.6237 51.1227 37.4189L51.1239 37.4304Z",
    fill: "#03825C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0136 26.7219C47.7953 17.1028 41.1936 9.42028 31.7848 9.58361C22.376 9.74694 13.7195 17.6974 13.9378 27.3134C13.9378 27.3134 13.597 46.8137 29.8818 62.7561C31.2304 63.8791 33.7444 63.7596 34.7702 62.6713C50.3188 46.1793 48.0165 26.7218 48.0165 26.7218L48.0136 26.7219ZM31.2239 37.9554C25.3123 38.0581 20.4106 33.2423 20.2736 27.2034C20.1365 21.1646 24.8187 16.1824 30.7274 16.0799C36.6361 15.9773 41.5407 20.7931 41.6777 26.8319C41.8148 32.8707 37.1326 37.8529 31.2239 37.9554Z",
    fill: "#03825C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9983 26.5405C49.7877 16.9337 41.9933 9.28661 32.591 9.4556C23.1887 9.62458 15.7356 17.5488 15.9461 27.1525C15.9461 27.1525 15.5902 46.6284 31.851 62.5405C32.9237 63.5904 34.634 63.5597 35.6599 62.4721C51.2105 45.9912 50.0013 26.5404 50.0013 26.5404L49.9983 26.5405ZM33.2117 37.7703C27.3041 37.8765 22.4098 33.0698 22.2775 27.0387C22.1453 21.0076 26.8281 16.0288 32.7327 15.9227C38.6373 15.8166 43.5346 20.6232 43.6669 26.6543C43.7991 32.6854 39.1163 37.6642 33.2117 37.7703Z",
    fill: "#2AC682"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2623 38.6616C39.5722 38.5482 44.5729 33.2329 44.4316 26.7895C44.2903 20.3461 39.0606 15.2145 32.7506 15.3279C26.4407 15.4413 21.4401 20.7566 21.5814 27.2001C21.7227 33.6435 26.9524 38.775 33.2623 38.6616Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5494 27.1891C30.0927 27.1793 30.5159 26.3853 30.4946 25.4157C30.4734 24.446 30.0157 23.6679 29.4725 23.6776C28.9292 23.6874 28.506 24.4814 28.5273 25.451C28.5485 26.4207 29.0061 27.1988 29.5494 27.1891Z",
    fill: "#03825C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1638 22.2182C28.6693 21.6903 29.6208 22.5972 30.6859 22.6026",
    stroke: "#03825C",
    strokeWidth: 0.685014,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9601 27.1845C36.4124 27.1717 35.982 26.3777 35.9988 25.4111C36.0156 24.4444 36.4732 23.6711 37.021 23.6839C37.5687 23.6967 37.9991 24.4907 37.9823 25.4573C37.9655 26.424 37.5078 27.1972 36.9601 27.1845Z",
    fill: "#03825C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3386 22.2281C37.8299 21.7094 36.8819 22.59 35.8158 22.589",
    stroke: "#03825C",
    strokeWidth: 0.685014,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8425 18.8891C35.3073 21.5557 21.4847 20.0002 16.1402 18.8891C15.7758 18.1484 16.5046 17.7781 16.869 17.7781C17.2334 17.7781 17.2334 17.4077 17.2334 17.0373C17.2334 16.667 17.2334 16.2966 17.9622 16.2966C18.691 16.2966 18.3266 15.9263 18.3266 15.5559C18.3266 15.2596 18.8124 15.1855 19.0554 15.1855C36.5463 18.5188 46.0205 15.1855 46.3849 15.1855C46.7493 15.1855 46.7493 15.5559 46.7493 15.9263C46.7493 16.2966 47.1137 16.2966 47.4781 16.667C47.8425 17.0373 47.8425 16.667 47.8425 17.4077C47.8425 18.1484 47.8425 17.7781 48.2069 18.1484C48.4984 18.4447 48.0854 18.7657 47.8425 18.8891Z",
    fill: "#03825C",
    stroke: "#03825C",
    strokeWidth: 1.26207
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1012 32.9629L58.1832 31.2561",
    stroke: "#005A44",
    strokeWidth: 4.04722,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9466 45.0164L50.6317 33.0137",
    stroke: "#005A44",
    strokeWidth: 4.04722,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1609 62.6475L47.8117 50.178C47.6618 48.7925 48.3555 45.9076 52.3296 45.4523C56.3037 44.997 57.5971 47.6541 57.747 49.0396L59.0962 61.5092",
    stroke: "#005A44",
    strokeWidth: 4.04722,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.743714,
    y: -0.594675,
    width: 3.72604,
    height: 24.6932,
    rx: 1.86302,
    transform: "matrix(0.993658 -0.112448 0.108898 0.994053 51.6631 49.0183)",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 1.34907
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.97763,
    height: 2.53423,
    rx: 1.26712,
    transform: "matrix(0.993658 -0.112448 0.108898 0.994053 36.5522 32.5215)",
    fill: "#212121"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.97763,
    height: 2.53423,
    rx: 1.26712,
    transform: "matrix(0.993658 -0.112448 0.108898 0.994053 55.1431 30.418)",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportive);
export default __webpack_public_path__ + "static/media/sportive.e1a5b9082851a0f8f5e5732054eb3538.svg";
export { ForwardRef as ReactComponent };